import { useEffect, useState, useCallback, useContext, createContext } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const Ctx = createContext({ modules: [], expired: false, all_modules: false, schools: [], loading: true, refresh: () => {} });

/**
 * Loads the active module set for the current user and shares it via context.
 * Wrap the dashboard tree once; pages call `useSubscription()` or `<ModuleGate />`.
 */
export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [data, setData] = useState({ modules: [], expired: false, all_modules: false, schools: [], loading: true });

  const refresh = useCallback(async () => {
    if (!user) { setData({ modules: [], expired: false, all_modules: false, schools: [], loading: false }); return; }
    try {
      const r = await api.get("/me/active-modules");
      setData({ ...r.data, loading: false });
    } catch {
      setData({ modules: [], expired: false, all_modules: false, schools: [], loading: false });
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return <Ctx.Provider value={{ ...data, refresh }}>{children}</Ctx.Provider>;
}

export function useSubscription() {
  return useContext(Ctx);
}

export function useHasModule(key) {
  const { modules, all_modules } = useContext(Ctx);
  return all_modules || (key && modules.includes(key));
}
